import {useEffect, useRef} from 'react'

import PropTypes from 'prop-types'

import {useOnScreen} from '@s-ui/react-hooks'

import {NEWS_DETAIL_BASE_CLASS} from '../../config.js'
import {SidebarBanner} from './SidebarBanner.js'
import {SidebarBestOffers} from './SidebarBestOffers.js'
import {SidebarNewsletterForm} from './SidebarNewsletterForm.js'
import {SidebarRelatedContent} from './SidebarRelatedContent.js'

export const Sidebar = ({children, onScreen}) => {
  const sidebarRef = useRef()
  const [isSidebarOnScreen] = useOnScreen({
    ref: sidebarRef,
    once: false
  })

  useEffect(() => {
    onScreen(isSidebarOnScreen)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSidebarOnScreen])

  return (
    <div className={`${NEWS_DETAIL_BASE_CLASS}-sidebarContent`} ref={sidebarRef}>
      {children}
    </div>
  )
}

const withIsShown = Component => {
  // eslint-disable-next-line react/prop-types
  return function WrappedComponent({isShown, ...props}) {
    if (!isShown) return null
    return <Component {...props} />
  }
}

Sidebar.Banner = withIsShown(SidebarBanner)
Sidebar.BestOffers = withIsShown(SidebarBestOffers)
Sidebar.NewsletterForm = withIsShown(SidebarNewsletterForm)
Sidebar.RelatedContent = withIsShown(SidebarRelatedContent)

Sidebar.propTypes = {
  children: PropTypes.node,
  onScreen: PropTypes.func
}
